import { t } from 'i18next'
import { z } from 'zod'

import { EstadoCivilEnum } from '@/types/cliente'
import { ClienteRegimeCasamentoEnum, tipoAssinaturaEnum } from '@/types/proposta'
import { telefoneSchema } from '@/utils/schemas/telefone.schema'

export const contatoSchema = z
  .object({
    telefone: telefoneSchema(),
    email: z
      .email({ error: t('proposta:cadastro_compradores.steps.contatos.erro.email_invalido') })
      .nullish()
      .refine((email) => !!email?.length, {
        message: t('proposta:cadastro_compradores.steps.contatos.erro.email_obrigatorio'),
      }),
  })
  .transform(({ telefone, ...rest }) => ({
    telefone: {
      ...telefone,
      origem: telefone!.origem,
      numero: telefone!.numero.replaceAll(/\D/g, ''),
    },
    email: rest.email!,
  }))
export type CompradorContatoSchemaOutput = z.output<typeof contatoSchema>

export const estadoCivilSchema = z.object({
  status: z
    .enum(EstadoCivilEnum, {
      error: (issue) =>
        issue.input === undefined ? t('configuracoes:pages.cores_lotes.validacao.cor_obrigatoria') : undefined,
    })
    .nullish(),
  uniaoEstavel: z.enum(['sim', 'nao', '']).nullish(),
  regimeCasamento: z.enum(ClienteRegimeCasamentoEnum).nullish(),
  tipoAssinatura: z.enum(tipoAssinaturaEnum).nullish(),
})

export type EstadoCivilSchemaInput = z.input<typeof estadoCivilSchema>

export const transformEstadoCivil = (data: z.infer<typeof estadoCivilSchema>) => {
  if (!data) return data
  return {
    ...data,
    possuiUniaoEstavel: data.uniaoEstavel ? data.uniaoEstavel === 'sim' : null,
    regimeCasamento: data.regimeCasamento ?? null,
  }
}
